import type { Token } from "./tokenizer";
import { TokenType } from "./tokenizer";

const normalizeNumberLiteral = (literal: string): string => {
  return literal.startsWith(".") ? `0${literal}` : literal.replace(/^0+(?=\d)/, "");
};

export const normalizeFormula = (tokens: Token[]): string => {
  return tokens
    .map((token) =>
      token.tokenType === TokenType.Number ? normalizeNumberLiteral(`${token.value}`) : `${token.value ?? ""}`
    )
    .join("");
};
